import PRPD from './PRPD/PRPD.vue'
import SPDG from './SPDG/SPDG.vue'
import SPDH from './SPDH/SPDH.vue'
import ILPF from './ILPF/ILPF.vue'
import SAF from './SAF/SAF.vue'
import FP from './FP/FP.vue'
import MRPA from './MRPA/MRPA.vue'
import TI from './TI/TI.vue'
import NONE from './NONE/NONE.vue'

const praticas = {
  PRPD,
  SPDG,
  SPDH,
  ILPF,
  SAF,
  FP,
  MRPA,
  TI,
  NONE
}

export default praticas



// WEBPACK FOOTER //
// ./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/index.js